<template>
    <van-row>
        <van-col span="24" class="Detail">
            <van-row>
                <van-col span="24" class="detail_v">
                    <van-row class="protitle">
                        <van-col span="24" class="protitle_v">{{info.title}}{{info.noid}}</van-col>
                    </van-row>
                    <van-row class="pro_second">
                        <van-col span="6"><van-tag color="#7232dd" >{{info.tag}}</van-tag></van-col>
                        <van-col span="6"><van-tag color="#7232dd" >{{info.risk}}</van-tag></van-col>
                        <van-col span="6"></van-col>
                        <van-col span="6"></van-col>
                    </van-row>
                    <van-row class="pro_third">
                        <van-col span="6">{{ $t("details.qryear")}}</van-col>
                        <van-col span="6"></van-col>
                        <van-col span="6">{{ $t("details.qx")}}</van-col>
                        <van-col span="6"></van-col>
                    </van-row>
                    <van-row class="pro_fourth">
                        <van-col span="6" class="shouyi">+{{info.profitRate}}</van-col>
                        <van-col span="6"></van-col>
                        <van-col span="6" class="qixian">{{info.term}}{{ $t("index.day")}}</van-col>
                        <van-col span="6"></van-col>
                    </van-row>
                </van-col>
            </van-row>
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "DetailTitle",
        data(){
            return{}
        },
        props:{
            info:{
                type:Object,
                required:true
            }
        }
    }
</script>

<style scoped lang="scss">
    .Detail{
        position: relative;
        overflow: hidden;
        height: 0;
        margin: 0 auto;
        padding-bottom: 50%;
        background: url("~@/assets/images/detail_bg.png") no-repeat;
        background-size: 100% 100%;
        .detail_v{
            width: 92%;
            height: 180px;
            margin: 25px auto 0 auto;
            position: absolute;
            left: 15px;
            bottom: 0;
            background: url("~@/assets/images/bg_financial_card.png")no-repeat;
            background-size: 100% 100%;
            color: white;
            .protitle{
                font-size: 16px;
                font-weight: bold;
                height: 35px;
                line-height:35px;
                margin: 8px auto;
                .protitle_v{
                    width: 98%;
                    margin:  0 auto;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-indent: 10px;
                }
            }
            .pro_second{
                height: 50px;
                /*line-height: 2rem;*/
            }
            .pro_third{
                height: 20px;
                line-height: 20px;
                color: #ddd;
            }
            .pro_fourth{
                height: 35px;
                line-height: 35px;
                .shouyi{
                    font-size: 25px;
                    font-weight: bold;
                    text-indent: 5px;
                    color: #e6f31b;

                }
                .qixian{
                    color: #e6f31b;
                    font-size: 18px;
                }
            }
        }
    }
</style>
